module.exports = "<!-- * CALL-TO-ACTION * -->\n<router-outlet></router-outlet>\n<!--<ddw-call-to-action-list></ddw-call-to-action-list>-->\n"